var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.427 6l4.279-4.279a1.013 1.013 0 000-1.427 1.012 1.012 0 00-1.426 0L6 4.574 1.72.294a1.013 1.013 0 00-1.427 0 1.015 1.015 0 000 1.427L4.573 6l-4.28 4.279a1.015 1.015 0 000 1.427 1.013 1.013 0 001.427 0L6 7.426l4.28 4.28a1.012 1.012 0 001.426 0 1.013 1.013 0 000-1.427L7.426 6z","fill":"#8E8E8E","fillRule":"evenodd"}));
}

Close.defaultProps = {"width":"12","height":"12"};

module.exports = Close;

Close.default = Close;
